import { useAllBrands } from "http-hooks/brand/useBrand";
import DeleteBrand from "components/brand/DeleteBrand";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  brandname: "",
  parentid: "",
  ag_status: "",
  page: 1,
  limit: 10,
  level: 1,
};

const columns = [
  { key: "brandname", header: "Name" },
  { key: "level", header: "Level" },
  {
    key: "boolbrandshow",
    header: "Show Brand",
    render: (item) => <StatusIcon value={item.boolbrandshow} />,
  },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function BrandMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("brand", id);

  const handleBrandSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, brandname: searchTerm, page: 1 }));
  };

  const handleStatusChange = (statusOption) => {
    setSelectedStatus(statusOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: statusOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allbrands, page: currentPage, totalPages } = [],
  } = useAllBrands(filter);

  return (
    <MasterPage
      title="Brand Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add brand</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleBrandSearch}
              label="Brand Name"
              placeholder="Search Brand Name"
            />
          </FilterCell>
          <FilterCell>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              options={statusOptions}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allbrands}
      isLoading={isLoading}
      rowKey="id"
      deleteComponent={DeleteBrand}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.id)}
            title="Edit Brand"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.id)}
            title="Delete Brand"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
